import PropTypes from 'prop-types';
import React from 'react';

import {
  OverviewButton,
  OverviewBadge,
  OverviewText,
  OverviewTitle,
  OverviewSubtitle,
  OverviewWaiting,
} from './SedeOverviewCard.style';
import { OverviewIcon } from './sedeIcons';

const waitingCount = (counters) => {
  const waiting = Number(counters?.waiting);
  return Number.isFinite(waiting) && waiting > 0 ? waiting : 0;
};

/** How many people wait in the given sedes, or 0 without counters. */
export const totalWaiting = (sedes, summary) => {
  if (!summary) return 0;
  return sedes.reduce((total, sede) => total + waitingCount(summary[sede.companyId]), 0);
};

/**
 * The way into the overview of all the sedes, over the list of sedes. It
 * shows how many people wait in the sedes it is given, when anyone does.
 */
const SedeOverviewCard = ({ sedes, summary, onOpen }) => {
  const waiting = totalWaiting(sedes, summary);

  return (
    <OverviewButton type="button" onClick={() => onOpen()}>
      <OverviewBadge aria-hidden="true">
        <OverviewIcon />
      </OverviewBadge>
      <OverviewText>
        <OverviewTitle>Vista general</OverviewTitle>
        <OverviewSubtitle>Todas las sedes en un vistazo</OverviewSubtitle>
      </OverviewText>
      {waiting > 0 && <OverviewWaiting>{`${waiting} esperando`}</OverviewWaiting>}
    </OverviewButton>
  );
};

SedeOverviewCard.propTypes = {
  sedes: PropTypes.arrayOf(PropTypes.shape({
    companyId: PropTypes.string.isRequired,
  })).isRequired,
  summary: PropTypes.objectOf(PropTypes.shape({
    waiting: PropTypes.number,
  })),
  onOpen: PropTypes.func.isRequired,
};

SedeOverviewCard.defaultProps = {
  summary: null,
};

export default SedeOverviewCard;
